export function ScrollArea({ className = "", children }) {
  return (
    <div
      className={`overflow-y-auto custom-scrollbar ${className}`}
      style={{
        scrollbarWidth: "thin",
        scrollbarColor: "rgb(98, 154, 196) #e5e7eb",
      }}
    >
      {children}
    </div>
  );
}
